/**
 * The entity kinds a `[Name](type:id)` mention token can address. Single source of
 * truth for the token's `type` segment, shared by the producer (mention insertion),
 * the parser's route table, and consumers that filter segments by kind — so the
 * wire format stays in lockstep across the stack.
 *
 * Only `users` is wired today; add an entry here (and a matching MENTION_ROUTES
 * builder) when a new mention target lands.
 */
export const MentionEntityType = {
    USERS: 'users',
} as const;

export type MentionEntityType = (typeof MentionEntityType)[keyof typeof MentionEntityType];
